<div class="afp-send" [formGroup]="form">
  <p class="afp-send__intro">
    {{ send.customerName }} will get one email listing these invoices. They can pay any or all of them from the link.
  </p>

  <div class="afp-send__invoices">
    <table>
      <thead>
        <tr>
          <th>Invoice</th>
          <th>Due</th>
          <th class="num">Balance</th>
        </tr>
      </thead>
      <tbody>
        @for (invoice of send.invoices; track invoice.invoiceRef) {
          <tr>
            <td>{{ invoice.invoiceRef }}</td>
            <td>{{ invoice.dueDate ? (invoice.dueDate | date : 'mediumDate') : '—' }}</td>
            <td class="num">{{ invoice.amount | currency }}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <tr>
          <td>{{ send.invoices.length }} invoice(s)</td>
          <td></td>
          <td class="num">{{ total | currency }}</td>
        </tr>
      </tfoot>
    </table>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Send to</mat-label>
    <mat-chip-grid #recipientGrid aria-label="Recipient email addresses">
      @for (email of recipients; track email) {
        <mat-chip-row (removed)="removeRecipient(email)">
          {{ email }}
          <button matChipRemove type="button" [attr.aria-label]="'Remove ' + email">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input
        placeholder="Add an email address"
        [matChipInputFor]="recipientGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeys"
        [matChipInputAddOnBlur]="true"
        (matChipInputTokenEnd)="addRecipient($event)"
      />
    </mat-chip-grid>
    <mat-hint>Prefilled from the customer's contact email. Press Enter or comma to add another.</mat-hint>
  </mat-form-field>
  @if (recipientError) {
    <div class="afp-send__error" role="alert">{{ recipientError }}</div>
  }

  <div class="afp-send__row">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Link valid until</mat-label>
      <input matInput type="date" formControlName="expiresDate" [min]="minDate" />
    </mat-form-field>
  </div>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Message to the customer (optional)</mat-label>
    <textarea matInput formControlName="message" rows="3" maxlength="1000"></textarea>
  </mat-form-field>

  <div class="afp-send__files">
    <div>
      <button mat-stroked-button type="button" (click)="fileInput.click()" [disabled]="attachments.length >= 5">
        <mat-icon>attach_file</mat-icon>
        Attach invoice files
      </button>
      <input #fileInput type="file" hidden multiple accept="application/pdf,image/png,image/jpeg" (change)="onFiles($event)" />
      <span class="afp-send__hint">&nbsp;Optional — up to 5 PDF/PNG/JPEG files, 2 MB each.</span>
    </div>
    @for (file of attachments; track file.filename; let i = $index) {
      <div class="afp-send__file">
        <mat-icon>description</mat-icon>
        <span>{{ file.filename }}</span>
        <button mat-icon-button type="button" (click)="removeAttachment(i)" [attr.aria-label]="'Remove ' + file.filename">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    }
    @if (fileError) {
      <div class="afp-send__error" role="alert">{{ fileError }}</div>
    }
  </div>
</div>
